import { Card, CardContent, Typography, CardActions, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const Error = () => {
  const { t } = useTranslation("common");
  return (
    <Card sx={{ 
      border: "none", 
      boxShadow: "none", 
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      height: {
        xs: "calc(100vh - 170px)"
      }
      }}>
      <CardContent>
        <Typography gutterBottom variant="h3">
          {t("pageNotFound")}
        </Typography>
      </CardContent>
      <CardActions>
        <Button href="#/dashboard" sx={{
          "&:hover": {
            color: "#ffffff"
          }
        }}>
          {t("backToDashboard")}
        </Button>
      </CardActions>
    </Card>
    )
}

export default Error
